/**
 * @generated SignedSource<<83577ed4478ab2609a76b180650f37a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskDeactivateInput = {
  task: string;
};
export type TaskActionsMutationButtonStack_taskDeactivateMutation$variables = {
  input: TaskDeactivateInput;
};
export type TaskActionsMutationButtonStack_taskDeactivateMutation$data = {
  readonly taskDeactivate: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"TaskActionsMutationButtonStack_task" | "TaskStatusLabel_task" | "TaskTaskHistoryPaginator_task">;
  };
};
export type TaskActionsMutationButtonStack_taskDeactivateMutation = {
  response: TaskActionsMutationButtonStack_taskDeactivateMutation$data;
  variables: TaskActionsMutationButtonStack_taskDeactivateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "order",
    "value": {
      "created": "DESC"
    }
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "before",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "after",
  "storageKey": null
},
v7 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Diff",
  "kind": "LinkedField",
  "name": "problem",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Diff",
  "kind": "LinkedField",
  "name": "solution",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v10 = [
  (v8/*: any*/),
  (v9/*: any*/)
],
v11 = [
  (v5/*: any*/),
  (v6/*: any*/),
  (v4/*: any*/)
],
v12 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "difficulty",
    "plural": false,
    "selections": (v11/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "unitDs",
    "plural": true,
    "selections": (v11/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "problem",
    "plural": false,
    "selections": (v11/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "solution",
    "plural": false,
    "selections": (v11/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "answer",
    "plural": false,
    "selections": (v11/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "answerChoiceCount",
    "plural": false,
    "selections": (v11/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Diff",
    "kind": "LinkedField",
    "name": "answerType",
    "plural": false,
    "selections": (v11/*: any*/),
    "storageKey": null
  }
],
v13 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v14 = [
  (v2/*: any*/)
],
v15 = [
  {
    "kind": "Literal",
    "name": "order",
    "value": {
      "order": "DESC"
    }
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v17 = [
  (v2/*: any*/),
  (v16/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "difficulty",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskActionsMutationButtonStack_taskDeactivateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "taskDeactivate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TaskStatusLabel_task"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TaskTaskHistoryPaginator_task"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TaskActionsMutationButtonStack_task"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaskActionsMutationButtonStack_taskDeactivateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "taskDeactivate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "TaskHistoryConnection",
            "kind": "LinkedField",
            "name": "histories",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskHistoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskHistory",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "picture",
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isDeleted",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "created",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "difference",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isDifference"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v10/*: any*/),
                            "type": "TaskProblemTypingDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "answerType",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "answer",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "answerChoiceCount",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              (v9/*: any*/)
                            ],
                            "type": "TaskProblemCreationDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v10/*: any*/),
                            "type": "TaskImageCreationDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v12/*: any*/),
                            "type": "TaskFirstLabelingDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v12/*: any*/),
                            "type": "TaskSecondLabelingDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v12/*: any*/),
                            "type": "TaskPublishDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "description",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "teacherName",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "title",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "type",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "TaskVideoDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "isPremium",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "isRecommended",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "taskVideoTitle",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "thumbnailHorizontalUrl",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "thumbnailVerticalUrl",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "TaskSolutionVideoDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "hint",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "specialAnswer",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "special",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "general",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "incorrect",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "correct",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "TaskHintFeedbackDifference",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "title",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "description",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "originalTask",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "creationType",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "assignedTo",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "TaskDifference",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "histories(first:10,order:{\"created\":\"DESC\"})"
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "filters": [
              "filters",
              "order"
            ],
            "handle": "connection",
            "key": "TaskTaskHistoryPaginator_task_histories",
            "kind": "LinkedHandle",
            "name": "histories"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "assignedTo",
            "plural": false,
            "selections": (v14/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskHint",
            "kind": "LinkedField",
            "name": "hint",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskSubmitFeedback",
            "kind": "LinkedField",
            "name": "submitFeedback",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "specialAnswer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "special",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "general",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Course",
            "kind": "LinkedField",
            "name": "course",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "year",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v15/*: any*/),
            "concreteType": "UnitD",
            "kind": "LinkedField",
            "name": "publishedUnitDs",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnitD",
                "kind": "LinkedField",
                "name": "nextUnitD",
                "plural": false,
                "selections": (v17/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnitD",
                "kind": "LinkedField",
                "name": "previousUnitD",
                "plural": false,
                "selections": (v17/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": "publishedUnitDs(order:{\"order\":\"DESC\"})"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMigrated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "migrationPair",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sequence",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskProblem",
            "kind": "LinkedField",
            "name": "problem",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "problem",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "solution",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "creationType",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "aiFile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "size",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "objectUrl",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v18/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskLabeling",
            "kind": "LinkedField",
            "name": "finalLabeling",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              {
                "alias": null,
                "args": (v15/*: any*/),
                "concreteType": "UnitD",
                "kind": "LinkedField",
                "name": "unitDs",
                "plural": true,
                "selections": (v14/*: any*/),
                "storageKey": "unitDs(order:{\"order\":\"DESC\"})"
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inMigrationPairSync",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c096374ed0337d8ccf5ada9177d362e7",
    "id": null,
    "metadata": {},
    "name": "TaskActionsMutationButtonStack_taskDeactivateMutation",
    "operationKind": "mutation",
    "text": "mutation TaskActionsMutationButtonStack_taskDeactivateMutation(\n  $input: TaskDeactivateInput!\n) {\n  taskDeactivate(input: $input) {\n    id\n    ...TaskStatusLabel_task\n    ...TaskTaskHistoryPaginator_task\n    ...TaskActionsMutationButtonStack_task\n  }\n}\n\nfragment DiffItem_diff on Diff {\n  before\n  after\n}\n\nfragment TaskActionsMutationButtonStack_task on Task {\n  id\n  actions\n  assignedTo {\n    id\n  }\n  ...TaskHintFeedbackPublishDialog_task\n  ...TaskMigrateDialog_task\n  ...TaskMigrationPairSyncDialog_task\n  difficulty\n  publishedUnitDs(order: {order: DESC}) {\n    id\n  }\n  finalLabeling {\n    difficulty\n    unitDs(order: {order: DESC}) {\n      id\n    }\n    id\n  }\n  inMigrationPairSync\n  problem {\n    id\n    problem\n    solution\n  }\n}\n\nfragment TaskDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskDifference {\n    title {\n      __typename\n    }\n    description {\n      __typename\n    }\n    status {\n      __typename\n    }\n    originalTask {\n      __typename\n    }\n    creationType {\n      __typename\n    }\n    assignedTo {\n      __typename\n    }\n  }\n}\n\nfragment TaskDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskDifference {\n    title {\n      ...DiffItem_diff\n    }\n    description {\n      ...DiffItem_diff\n    }\n    status {\n      ...DiffItem_diff\n    }\n    originalTask {\n      ...DiffItem_diff\n    }\n    creationType {\n      ...DiffItem_diff\n    }\n    assignedTo {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskFirstLabelingDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskFirstLabelingDifference {\n    difficulty {\n      __typename\n    }\n    unitDs {\n      __typename\n    }\n    problem {\n      __typename\n    }\n    solution {\n      __typename\n    }\n    answer {\n      __typename\n    }\n    answerChoiceCount {\n      __typename\n    }\n    answerType {\n      __typename\n    }\n  }\n}\n\nfragment TaskFirstLabelingDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskFirstLabelingDifference {\n    difficulty {\n      ...DiffItem_diff\n    }\n    unitDs {\n      ...DiffItem_diff\n    }\n    problem {\n      ...DiffItem_diff\n    }\n    solution {\n      ...DiffItem_diff\n    }\n    answer {\n      ...DiffItem_diff\n    }\n    answerChoiceCount {\n      ...DiffItem_diff\n    }\n    answerType {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskHintFeedbackDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskHintFeedbackDifference {\n    hint {\n      __typename\n    }\n    specialAnswer {\n      __typename\n    }\n    special {\n      __typename\n    }\n    general {\n      __typename\n    }\n    incorrect {\n      __typename\n    }\n    correct {\n      __typename\n    }\n  }\n}\n\nfragment TaskHintFeedbackDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskHintFeedbackDifference {\n    hint {\n      ...DiffItem_diff\n    }\n    specialAnswer {\n      ...DiffItem_diff\n    }\n    special {\n      ...DiffItem_diff\n    }\n    general {\n      ...DiffItem_diff\n    }\n    incorrect {\n      ...DiffItem_diff\n    }\n    correct {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskHintFeedbackPublishDialog_task on Task {\n  id\n  hint {\n    id\n    text\n  }\n  submitFeedback {\n    id\n    specialAnswer\n    special\n    general\n  }\n}\n\nfragment TaskHistoryDialog_taskHistory on TaskHistory {\n  createdBy {\n    name\n    picture\n    id\n  }\n  created\n  difference {\n    __typename\n    ...TaskProblemTypingDifferenceCounterLabel_difference\n    ...TaskProblemTypingDifferenceItemList_difference\n    ...TaskProblemCreationDifferenceCounterLabel_difference\n    ...TaskProblemCreationDifferenceItemList_difference\n    ...TaskImageCreationDifferenceCounterLabel_difference\n    ...TaskImageCreationDifferenceItemList_difference\n    ...TaskFirstLabelingDifferenceItemList_difference\n    ...TaskFirstLabelingDifferenceCounterLabel_difference\n    ...TaskSecondLabelingDifferenceItemList_difference\n    ...TaskSecondLabelingDifferenceCounterLabel_difference\n    ...TaskPublishDifferenceItemList_difference\n    ...TaskPublishDifferenceCounterLabel_difference\n    ...TaskVideoDifferenceCounterLabel_difference\n    ...TaskVideoDifferenceItemList_difference\n    ...TaskSolutionVideoDifferenceCounterLabel_difference\n    ...TaskSolutionVideoDifferenceItemList_difference\n    ...TaskHintFeedbackDifferenceItemList_difference\n    ...TaskHintFeedbackDifferenceCounterLabel_difference\n    ...TaskDifferenceItemList_difference\n    ...TaskDifferenceCounterLabel_difference\n  }\n}\n\nfragment TaskHistoryTimelineItem_taskHistory on TaskHistory {\n  created\n  createdBy {\n    id\n    ...UserAvatarText_user\n  }\n  type\n}\n\nfragment TaskImageCreationDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskImageCreationDifference {\n    problem {\n      __typename\n    }\n    solution {\n      __typename\n    }\n  }\n}\n\nfragment TaskImageCreationDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskImageCreationDifference {\n    problem {\n      ...DiffItem_diff\n    }\n    solution {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskMigrateDialog_task on Task {\n  id\n  course {\n    id\n    year\n  }\n  publishedUnitDs(order: {order: DESC}) {\n    id\n    description\n    nextUnitD {\n      id\n      description\n    }\n    previousUnitD {\n      id\n      description\n    }\n  }\n}\n\nfragment TaskMigrationPairSyncDialog_task on Task {\n  id\n  isMigrated\n  migrationPair {\n    id\n    sequence\n  }\n  problem {\n    problem\n    solution\n    creationType\n    id\n  }\n  aiFile {\n    key\n    size\n    objectUrl\n    id\n  }\n}\n\nfragment TaskProblemCreationDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskProblemCreationDifference {\n    answerType {\n      __typename\n    }\n    answer {\n      __typename\n    }\n    answerChoiceCount {\n      __typename\n    }\n    problem {\n      __typename\n    }\n    solution {\n      __typename\n    }\n  }\n}\n\nfragment TaskProblemCreationDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskProblemCreationDifference {\n    answer {\n      ...DiffItem_diff\n    }\n    answerChoiceCount {\n      ...DiffItem_diff\n    }\n    answerType {\n      ...DiffItem_diff\n    }\n    problem {\n      ...DiffItem_diff\n    }\n    solution {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskProblemTypingDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskProblemTypingDifference {\n    problem {\n      __typename\n    }\n    solution {\n      __typename\n    }\n  }\n}\n\nfragment TaskProblemTypingDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskProblemTypingDifference {\n    problem {\n      ...DiffItem_diff\n    }\n    solution {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskPublishDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskPublishDifference {\n    difficulty {\n      __typename\n    }\n    unitDs {\n      __typename\n    }\n    problem {\n      __typename\n    }\n    solution {\n      __typename\n    }\n    answer {\n      __typename\n    }\n    answerChoiceCount {\n      __typename\n    }\n    answerType {\n      __typename\n    }\n  }\n}\n\nfragment TaskPublishDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskPublishDifference {\n    difficulty {\n      ...DiffItem_diff\n    }\n    unitDs {\n      ...DiffItem_diff\n    }\n    problem {\n      ...DiffItem_diff\n    }\n    solution {\n      ...DiffItem_diff\n    }\n    answer {\n      ...DiffItem_diff\n    }\n    answerChoiceCount {\n      ...DiffItem_diff\n    }\n    answerType {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskSecondLabelingDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskSecondLabelingDifference {\n    difficulty {\n      __typename\n    }\n    unitDs {\n      __typename\n    }\n    problem {\n      __typename\n    }\n    solution {\n      __typename\n    }\n    answer {\n      __typename\n    }\n    answerChoiceCount {\n      __typename\n    }\n    answerType {\n      __typename\n    }\n  }\n}\n\nfragment TaskSecondLabelingDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskSecondLabelingDifference {\n    difficulty {\n      ...DiffItem_diff\n    }\n    unitDs {\n      ...DiffItem_diff\n    }\n    problem {\n      ...DiffItem_diff\n    }\n    solution {\n      ...DiffItem_diff\n    }\n    answer {\n      ...DiffItem_diff\n    }\n    answerChoiceCount {\n      ...DiffItem_diff\n    }\n    answerType {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskSolutionVideoDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskSolutionVideoDifference {\n    isPremium {\n      before\n      after\n    }\n    isRecommended {\n      before\n      after\n    }\n    taskVideoTitle {\n      before\n      after\n    }\n    thumbnailHorizontalUrl {\n      before\n      after\n    }\n    thumbnailVerticalUrl {\n      before\n      after\n    }\n  }\n}\n\nfragment TaskSolutionVideoDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskSolutionVideoDifference {\n    taskVideoTitle {\n      ...DiffItem_diff\n    }\n    isPremium {\n      ...DiffItem_diff\n    }\n    thumbnailHorizontalUrl {\n      ...DiffItem_diff\n    }\n    thumbnailVerticalUrl {\n      ...DiffItem_diff\n    }\n    isRecommended {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment TaskStatusLabel_task on Task {\n  status\n}\n\nfragment TaskTaskHistoryPaginator_task on Task {\n  histories(order: {created: DESC}, first: 10) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        type\n        ...TaskHistoryDialog_taskHistory\n        ...TaskHistoryTimelineItem_taskHistory\n        __typename\n      }\n    }\n  }\n  id\n}\n\nfragment TaskVideoDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on TaskVideoDifference {\n    description {\n      before\n      after\n    }\n    teacherName {\n      before\n      after\n    }\n    title {\n      before\n      after\n    }\n    type {\n      before\n      after\n    }\n  }\n}\n\nfragment TaskVideoDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on TaskVideoDifference {\n    title {\n      ...DiffItem_diff\n    }\n    description {\n      ...DiffItem_diff\n    }\n    teacherName {\n      ...DiffItem_diff\n    }\n    type {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "eb6602a3e6060f5b98651704e9f60197";

export default node;
